module.exports = __webpack_public_path__ + "img/img_index_banner_k@2x.bd05f794.png";